export const Config = {
  APP_CODE: 'CEN001',
  CONSUMER_APP_CODE: 'CEN002',
  PERSIST_ROOT_STORAGE: '@center:root',
  PERSIST_OTHER_STORAGE: '@center:other',
  PERSIST_DATA: ['auth', 'cart', 'item', 'consumer'],
  MIN_PO_QTY: 7000,
  PO_ADVANCE_PERCENTAGE: 50,
};
